import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import LogoBar from './components/LogoBar';
import WhyEmbrace from './components/WhyEmbrace';
import Stats from './components/Stats';
import Services from './components/Services';
import VideoSection from './components/VideoSection';
import Team from './components/Team';
import Approach from './components/Approach';
import Location from './components/Location';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AppointmentModal from './components/AppointmentModal';
import ThankYouModal from './components/ThankYouModal'; // Ensure this is imported properly without {} based on your file setup
import PrivacyModal from './components/PrivacyModal';
import DisclaimerModal from './components/DisclaimerModal';
import TermsModal from './components/TermsModal';
import './App.css';

function App() {
    const [showModal, setShowModal] = useState(false);
    const [showThankYou, setShowThankYou] = useState(false);
    const [showPrivacy, setShowPrivacy] = useState(false);
    const [showDisclaimer, setShowDisclaimer] = useState(false);
    const [showTerms, setShowTerms] = useState(false);

    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);
    const handleSuccess = () => {
        setShowModal(false);
        setShowThankYou(true);
    };

    return (
        <div className="App">
            <Navbar openModal={openModal} />
            <Hero openModal={openModal} />
            <LogoBar />
            <WhyEmbrace openModal={openModal} />
            <Stats />
            <Services openModal={openModal} />
            <VideoSection />
            <Team />
            <Approach />

            <Location />
            <Contact onSuccess={handleSuccess} />
            <Footer 
                openModal={openModal} 
                openPrivacyModal={() => setShowPrivacy(true)}
                openDisclaimerModal={() => setShowDisclaimer(true)}
                openTermsModal={() => setShowTerms(true)}
            />

            {showModal && <AppointmentModal closeModal={closeModal} onSuccess={handleSuccess} />}
            {showThankYou && <ThankYouModal close={() => setShowThankYou(false)} />}
            {showPrivacy && <PrivacyModal closeModal={() => setShowPrivacy(false)} />}
            {showDisclaimer && <DisclaimerModal closeModal={() => setShowDisclaimer(false)} />}
            {showTerms && <TermsModal closeModal={() => setShowTerms(false)} />}
        </div>
    );
}

export default App;
